import { render, staticRenderFns } from "./CommentSheet.vue?vue&type=template&id=7847b656&scoped=true"
import script from "./CommentSheet.vue?vue&type=script&lang=js"
export * from "./CommentSheet.vue?vue&type=script&lang=js"
import style0 from "./CommentSheet.vue?vue&type=style&index=0&id=7847b656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847b656",
  null
  
)

export default component.exports